var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 17.0751 4.92487 22 11 22 17.0751 22 22 17.0751 22 11 22 4.92487 17.0751.0 11 0 4.92487.0.0 4.92487.0 11zm20 0C20 15.9706 15.9706 20 11 20 6.02944 20 2 15.9706 2 11c0-4.97056 4.02944-9 9-9C15.9706 2 20 6.02944 20 11zm-8.9997 4.9983C11.5528 15.9983 12.0007 15.5506 12.0007 14.9983 12.0007 14.4461 11.5528 13.9983 11.0003 13.9983 10.4479 13.9983 10 14.4461 10 14.9983 10 15.5506 10.4479 15.9983 11.0003 15.9983zM10 13h2C12 12.2016 12.1254 12.0553 12.9472 11.6444 14.3754 10.9303 15 10.2016 15 8.5 15 6.32063 13.2843 5 11 5 8.79086 5 7 6.79086 7 9H9C9 7.89543 9.89543 7 11 7 12.2772 7 13 7.55641 13 8.5 13 9.29835 12.8746 9.44468 12.0528 9.85557 10.6246 10.5697 10 11.2984 10 13z",
    fill: "#006aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.21ab994b.svg";
export { ForwardRef as ReactComponent };